module.exports = __webpack_public_path__ + "static/media/img2.367c357f.jpeg";